import { UserAction } from 'src/app/content-management/shared/enums/user-action';

export class UserState {
  constructor(
    public contentId?: string,
    public username?: string,
    public email?: string,
    public action?: UserAction
  ) {}
}
